import { useCallback } from 'react';
import { adicionarProtocoloUrl } from '../../../../utils/adicionar-protocolo-url';
import { useAppEmbarcado } from '../../../app/hooks';
import { HookResult } from './use-link-externo.types';

export const useLinkExterno = (): HookResult => {
  const { isAppEmbarcado } = useAppEmbarcado();

  /**
   * @description
   * Esta função tem como objetivo abrir links em novas guias.
   *
   * Casos:
   * - Caso seja passada uma URL completa, o link é aberto
   * - Caso seja passada uma URL completa, porém sem protocolo, então é adicionado o protocolo e o link é aberto
   * - Caso seja passado um path começando com '/' (ex: /aura-repo/arquivos/arquivo.txt) será aberto concatenando o location atual
   */
  const acessarLinkExterno = useCallback(
    (url: string, janela: '_blank' | '_self' = '_blank'): void => {
      const linkTratado = url.startsWith('/') ? url : adicionarProtocoloUrl(url);

      if (isAppEmbarcado) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).ReactNativeWebView.postMessage(`{"method": "openExternalBrowser", "url": "${linkTratado}" }`);
      } else {
        window.open(linkTratado, janela, 'noopener');
      }
    },
    [isAppEmbarcado],
  );

  return { acessarLinkExterno };
};
